export const HEAP_APP_ID_MAP = {
  development: '215362594',
  test: '215362594',
  production: '385482089',
};

export const HEAP_API_URL = 'https://heapanalytics.com/api/track';
